import { useEffect } from 'react';
import { SubscribeReturn, TimelineMarkersConsumer } from '../TimelineMarkersContext';
import { MarkerRendererType, MarkerType, TimelineMarkerType } from '../markerType';

export interface CursorMarkerProps {
  subscribeMarker: (m: MarkerType) => SubscribeReturn;
  children: MarkerRendererType;
}

function CursorMarkerInner({ subscribeMarker, children }: CursorMarkerProps) {
  useEffect(() => {
    const { unsubscribe } = subscribeMarker({
      type: TimelineMarkerType.Cursor,
      renderer: children,
    });
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [subscribeMarker, children]);

  return null;
}

export type CursorMarkerWrapperProps = Pick<CursorMarkerProps, 'children'>;

function CursorMarkerWrapper(props: CursorMarkerWrapperProps) {
  return (
    <TimelineMarkersConsumer>
      {({ subscribeMarker }) => <CursorMarkerInner subscribeMarker={subscribeMarker} {...props} />}
    </TimelineMarkersConsumer>
  );
}

CursorMarkerWrapper.displayName = 'CursorMarker';

export default CursorMarkerWrapper;
